import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-knowledgeitems',
  templateUrl: './knowledgeitems.page.html',
  styleUrls: ['./knowledgeitems.page.scss'],
})
export class KnowledgeitemsPage implements OnInit {
  knowledgeId:string;
  constructor(private route: ActivatedRoute,private router: Router) { }

  ngOnInit() {
    this.knowledgeId = this.route.snapshot.paramMap.get('id');
    if(this.knowledgeId){
      localStorage.knowledgeData = "true";
      localStorage.knowledgeId = this.knowledgeId;
    }
    this.router.navigate(['/dashboard'], { replaceUrl: true });
  }

}
